<script>
export default {
    props:{
        type:String,
        status:String,
        cat:Number,
    },
    computed:{
        data(){
            if(this.type=="type-budget"){
                return {
                    '1': {style:"info",label:"In"},
                    '2': {style:"success",label:"Out"},
                    '3': {style:"danger",label:"In Out"},
                }[this.cat]
            }
            return {
                "Y": {style:"success",label:"Active"},
                "N": {style:"warning",label:"Inactive"},
                "P": {style:"danger",label:"Pending"},
            }[this.status.toUpperCase()]
        }
    }
}
</script>

<template>
    <label :class="'label label-'+(data.style)">{{data.label}}</label>
</template>